// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto } from './IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto';
import {
    IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON,
    IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSONTyped,
    IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSON,
    IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto';
import type { IPayrollContributionsMultiEmployersSummaryRecordDto } from './IPayrollContributionsMultiEmployersSummaryRecordDto';
import {
    IPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON,
    IPayrollContributionsMultiEmployersSummaryRecordDtoFromJSONTyped,
    IPayrollContributionsMultiEmployersSummaryRecordDtoToJSON,
    IPayrollContributionsMultiEmployersSummaryRecordDtoToJSONTyped,
} from './IPayrollContributionsMultiEmployersSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto
 */
export interface IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto
     */
    employer_name?: string;
    /**
     * 
     * @type {Array<IPayrollContributionsMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto
     */
    employer_records?: Array<IPayrollContributionsMultiEmployersSummaryRecordDto>;
    /**
     * 
     * @type {Array<IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto>}
     * @memberof IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto
     */
    subsidiary_groups?: Array<IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto(value: object): value is IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    return true;
}

export function IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON(json: any): IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'employer_records': json['employer_records'] == null ? undefined : ((json['employer_records'] as Array<any>).map(IPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON)),
        'subsidiary_groups': json['subsidiary_groups'] == null ? undefined : ((json['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSON(json: any): IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto {
    return IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSONTyped(value?: IReportSummaryDtoPayrollContributionsMultiEmployersSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employer_name': value['employer_name'],
        'employer_records': value['employer_records'] == null ? undefined : ((value['employer_records'] as Array<any>).map(IPayrollContributionsMultiEmployersSummaryRecordDtoToJSON)),
        'subsidiary_groups': value['subsidiary_groups'] == null ? undefined : ((value['subsidiary_groups'] as Array<any>).map(IReportSummaryGroupDtoPayrollContributionsMultiEmployersSummaryRecordDtoToJSON)),
    };
}

